import { useSelector } from 'react-redux';
import { languagesSelector } from 'slices/language.slice';
import type { TAltDesignations, TLanguage } from '@timeedit/types/lib/types';
import { Icon } from '@timeedit/ui-components';
import { Dropdown, type MenuProps, Space } from '@timeedit/ui-components/antd';
import './AltDesignationFooter.scss';

type AltDesignationFooterProps = {
  onClick: (e: any) => void;
  usedAltDesignations: TAltDesignations[];
};

export const AltDesignationFooter = ({
  usedAltDesignations,
  onClick,
}: AltDesignationFooterProps) => {
  const allLanguages = useSelector(languagesSelector);
  const items: MenuProps['items'] = allLanguages
    ?.filter((lang: TLanguage) => lang.isActive)
    ?.filter(
      (lang: TLanguage) =>
        !usedAltDesignations.some(
          (altDesignation: TAltDesignations) =>
            altDesignation.language === lang.id
        )
    )
    ?.map((lang: TLanguage) => ({
      label: lang.name,
      key: lang.id,
    }));

  return (
    <div className="alt-designation-footer">
      <Dropdown menu={{ items, onClick: (e) => onClick(e.key) }}>
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            Add
            <Icon id="DownOutlined" alt="Down" />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
};
